import { render, staticRenderFns } from "./CreditBillingBillingRuns.vue?vue&type=template&id=70dd94f4&scoped=true&"
import script from "./CreditBillingBillingRuns.vue?vue&type=script&lang=js&"
export * from "./CreditBillingBillingRuns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dd94f4",
  null
  
)

export default component.exports